<template>
  <section id="introduction" class="section__interview c__section section__01">
    <div class="c__container_full">
      <div class="main__contents__wrap">
        <div class="c__headblock">
          <p class="c__leadcopy navy ac">パジャマで、疲労回復。</p>
          <p class="c__bodycopy navy ac al__sp">
            TENTIALが開発したリカバリーウェア〈BAKUNE〉は、<br class="hidden-xs" />
            上質な休息によって心と身体を整えることを目的に生まれました。<br />
            発売以来、多くのお客様からいただいた声をもとに、素材やシルエット、シーンに合わせた<br class="hidden-xs" />
            多彩なバリエーションへとアップデートを重ねてきました。<br /><br />
            BAKUNEシリーズの素材や特徴を比較しながら、<br class="hidden-xs" />
            あなたのお気に入りの1着を一緒に見つけましょう。
          </p>
          <div class="page__index">
            <h2>Contents</h2>
            <div class="anchor__wrap">
              <a @click="scrollToId('product_list')">
                <div class="dot"></div>
                <p>人気の商品</p>
                <AtomsConsumerImage
                  src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
                  alt="arrow"
                  :width="10"
                  :height="8"
                  class="arrow"
                />
              </a>
              <a @click="scrollToId('feature')">
                <div class="dot"></div>
                <p>BAKUNEのこだわり</p>
                <AtomsConsumerImage
                  src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
                  alt="arrow"
                  :width="10"
                  :height="8"
                  class="arrow"
                />
              </a>
              <a @click="scrollToId('silhouette')">
                <div class="dot"></div>
                <p>シルエットでえらぶ</p>
                <AtomsConsumerImage
                  src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
                  alt="arrow"
                  :width="10"
                  :height="8"
                  class="arrow"
                />
              </a>
              <a @click="scrollToId('textile')">
                <div class="dot"></div>
                <p>素材で選ぶ</p>
                <AtomsConsumerImage
                  src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
                  alt="arrow"
                  :width="10"
                  :height="8"
                  class="arrow"
                />
              </a>
              <a @click="scrollToId('color')">
                <div class="dot"></div>
                <p>色で選ぶ</p>
                <AtomsConsumerImage
                  src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
                  alt="arrow"
                  :width="10"
                  :height="8"
                  class="arrow"
                />
              </a>
              <a @click="scrollToId('favorite')">
                <div class="dot"></div>
                <p>あなた好みの1着をみつける</p>
                <AtomsConsumerImage
                  src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
                  alt="arrow"
                  :width="10"
                  :height="8"
                  class="arrow"
                />
              </a>
              <a @click="scrollToId('compare')">
                <div class="dot"></div>
                <p>比較する</p>
                <AtomsConsumerImage
                  src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
                  alt="arrow"
                  :width="10"
                  :height="8"
                  class="arrow"
                />
              </a>
              <div class="modal__btn" @click="emit('openModal')">
                <p>全ての商品を見る</p>
                <div class="plus"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: "openModal"): void
}>()

const scrollToId = (documentId: string): void => {
  const element = document.getElementById(documentId)
  element?.scrollIntoView({
    behavior: "smooth",
  })
}
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
